import {Injectable, Query} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';

import {QueryResult} from "../classes/query-result";
import {Transaction} from '../enums/txn-type.enum';
import {DefaultChargeCode} from "../charge-code//default-charge-code/charge-code-summary";
import {CommonTransformationService} from './common-transformation.service';
import {ChargeCode, ChargeCodeProperty} from "@app/shared/classes/charge-code";
import {map} from "rxjs/operators";

@Injectable()
export class ChargeCodeService {

  DefaultChargeCodeProperties = [
    ChargeCodeProperty.ChargeNumber,
    ChargeCodeProperty.Name
  ];
  ProjectWorkLocationCacheIndexIdentifier = "ProjectWorkLocations";

  constructor(private http: HttpClient, private transform: CommonTransformationService) {
  }

  getChargeCodeById(chargeCodeId: number): Observable<ChargeCode> {
    const url = `/finance/charge-codes/${chargeCodeId}`;
    return this.http.get<ChargeCode>(url);
  }

  getChargeCodesOwnedBySelf(): Observable<QueryResult> {
    const url = `/finance/charge-codes/authorized/owner`;
    return this.http.get<QueryResult>(url);
  }

  getMyChargeCodeAsDropdown(txnType: Transaction, authorizedFrom: string, authorizedThru?: string, labelProperties?: string[]): Observable<any> {
    let url = `/finance/charge-codes/authorized/self?transaction=${txnType}&authorizedFrom=${authorizedFrom}`;

    if (authorizedThru) {
      url += `&authorizedThru=${authorizedThru}`;
    }

    if (labelProperties) {
      return this.http.get<QueryResult>(url).pipe(map(res => {
        return this.transform.convertToLongLabelDropDown(labelProperties, res.list, null, true);
      }));
    } else {
      return this.http.get<QueryResult>(url).pipe(map(res => {
        return this.transform.convertToDropDown("name", res.list, "id", true);
      }));
    }
  }

  getChargeCodeForUserAsDropdown(txnType: Transaction, authorizedFrom: string, authorizedThru?: string, labelProperties?: string[], userId?: number): Observable<any> {
    let url = `/finance/charge-codes/authorized/user/${userId}?transaction=${txnType}&effectiveFrom=${authorizedFrom}`;

    if (authorizedThru) {
      url += `&effectiveThru=${authorizedThru}`;
    }

    if (labelProperties) {
      return this.http.get<QueryResult>(url).pipe(map(res => {
        return this.transform.convertToLongLabelDropDown(labelProperties, res.list, null, true);
      }));
    } else {
      return this.http.get<QueryResult>(url).pipe(map(res => {
        return this.transform.convertToDropDown("name", res.list, "id", true);
      }));
    }
  }

  searchChargeCode(keyword: string): Observable<any> {
    const url = "/finance/charge-codes/any/search?searchString=" + keyword;
    return this.http.get<QueryResult>(url);
  }

  searchChargeCodesAsDropdown(keyword: string, labelProperties?: string[]): Observable<any> {
    let url: string = "/finance/charge-codes/any/search?searchString=" + keyword;

    if (labelProperties) {
      return this.http.get<any>(url).pipe(map(res => {
        return this.transform.convertToLongLabelDropDown(labelProperties, res.list);
      }));
    } else {
      return this.http.get<any>(url).pipe(map(res => {
        return this.transform.convertToDropDown("name", res.list, "id");
      }));
    }
  }

  getMyDefaultChargeCodes(txnType: Transaction, subTypeId: number, authorizedFrom: string, authorizedThru?: string): Observable<QueryResult> {
    let url = `/finance/charge-codes/default/self?transaction=${txnType}&subTypeId=${subTypeId}&authorizedFrom=${authorizedFrom}`;
    if (authorizedThru) {
      url += `&authorizedThru=${authorizedThru}`;
    }
    return this.http.get<QueryResult>(url);
  }

  saveMyDefaultChargeCodes(list: DefaultChargeCode[]): Observable<QueryResult> {
    let url: string = "/finance/charge-codes/default/self";

    if (list != null && list.length > 0) {
      for (let dcc of list) {
        delete dcc.authorizedFrom;
        delete dcc.authorizedThru;
        delete dcc.chargeCodeOwner;
        delete dcc.expenseAccountGroupName;
        delete dcc.laborAccountGroupName;
        delete dcc.purchaseAccountGroupName;
      }
      return this.http.post<QueryResult>(url, list);
    }
  }

  deleteAllMyDefaultChargeCodes(txnType: Transaction, subTypeId: number): Observable<any> {
    let url: string = "/finance/charge-codes/default/self/?transaction=" + txnType + "&subTypeId=" + subTypeId;

    return this.http.delete<QueryResult>(url);
  }

  getIndexForChargeCode(txnType: Transaction, identifier: string, userId: number): string {
    let index: string = "";
    if (userId) {
      index += userId;
    }
    index += txnType;
    index += identifier;
    return index;
  }
}
